// @flow
const StreamType: PKStreamTypes = {
  DASH: 'dash',
  HLS: 'hls',
  PROGRESSIVE: 'progressive'
};

export {StreamType};



// WEBPACK FOOTER //
// ./engines/stream-type.js


// WEBPACK FOOTER //
// core/engines/stream-type.js